import { render, staticRenderFns } from "./RequiredIndicator.vue?vue&type=template&id=f0f404a8&scoped=true"
import script from "./RequiredIndicator.vue?vue&type=script&lang=js"
export * from "./RequiredIndicator.vue?vue&type=script&lang=js"
import style0 from "./RequiredIndicator.vue?vue&type=style&index=0&id=f0f404a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f404a8",
  null
  
)

export default component.exports